import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import { Form, Field } from 'simple-react-form'
import ArrayComponent from 'orionsoft-parts/lib/components/fields/ArrayComponent'
import ProductField from './ProductField'
import getDescription from 'App/helpers/SecuritySatProducts/getDescription'
import Total from './Total'
import PayForm from './PayForm'
import EspecialValues from './EspecialValues'
import Save from './Save'

export default class AdvanceForm extends React.Component {
  static propTypes = {
    sellNoteId: PropTypes.string,
    preparationId: PropTypes.string,
    formData: PropTypes.object
  }

  state = {}

  componentDidMount() {
    const { formData } = this.props
    this.setState(formData)
  }

  productData = (codigo, index, products) => {
    const descriptions = getDescription(products)
    const { productArray } = this.state
    productArray[index] = {
      codigo: codigo,
      description: descriptions[codigo]
    }
    this.setState({ productArray })
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="content">
          <Form state={this.state} onChange={changes => this.setState(changes)}>
            <div className={styles.arrayComponent}>
              <Field
                fieldName="productArray"
                label="Formulario por producto agregado"
                draggable={false}
                type={ArrayComponent}
                addLabel="Agregar producto"
                renderItem={(item, index) => (
                  <Field
                    fieldName="product"
                    label="product"
                    type={ProductField}
                    index={index}
                    codigo={item.codigo}
                    productData={this.productData}
                    productPrice={this.productPrice}
                    oneTotalPrice={this.oneTotalPrice}
                  />
                )}
              />
            </div>
            <div className={styles.pay}>
              <Field fieldName="payform" type={PayForm} />
            </div>
            <div className={styles.especial}>
              <Field fieldName="especialValues" type={EspecialValues} />
            </div>
            <div className={styles.calc}>
              <Field fieldName="calc" type={Total} />
            </div>
          </Form>
          <Save
            formData={this.state}
            sellNoteId={this.props.sellNoteId}
            preparationId={this.props.preparationId}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/index.js